import {
  B_FLOW_ID,
  C_B_FLOW_ID,
  C_FLOW_ID,
  C_PL_FLOW_ID,
  PL_B_FLOW_ID,
  PL_FLOW_ID,
  TRIPLE_FLOW_ID,
} from '../boilerplate/item-ids';

/**
 * Validation rule `initial_validator`
 * Checks if `item_id` has value from touchpoint manifest
 *
 * @example usage in field definition:
 * `initial_validator`
 */
export default (kasko) => () => {
  const formState = kasko.getFormState();
  const routeState = kasko.getState('route');

  const itemId = formState.item_id;

  if (routeState.state.url !== '/initial') {
    return null;
  }

  if (
    itemId === TRIPLE_FLOW_ID ||
    itemId === C_FLOW_ID ||
    itemId === B_FLOW_ID ||
    itemId === PL_FLOW_ID ||
    itemId === C_PL_FLOW_ID ||
    itemId === C_B_FLOW_ID ||
    itemId === PL_B_FLOW_ID
  ) {
    return null;
  }

  return { initial_validator: true };
};
